import React, {useEffect,useRef} from 'react';
import {Radio,RadioGroup,FormControlLabel} from '@material-ui/core';
import {PREPAY_REVIEW_URL} from '../eir-prepay-constants/ApplicationConstants';

function EirMobileCardToggle(props) { 
    const radioPrepay = useRef(null);
    const radioHandset = useRef(null);
    useEffect(()=>{
        if(localStorage.getItem('planToggle')){
           radioHandset.current.click();
        }else{
           radioPrepay.current.click();
        }
    },[]);
    return (             
          <div>
            <RadioGroup
            aria-label="Prepay Plan"
            name="phoneplan"
            className='radio-group'
            >
            <FormControlLabel ref={radioPrepay} className='white-background margin-radio'  value="prepay" control={<Radio color="primary" onClick={handleChange}  url={PREPAY_REVIEW_URL}/>} label="New Prepay SIM"/>
            <FormControlLabel ref={radioHandset} className='white-background' value="handset" control={<Radio color="primary"  onClick={handleChange} url='/mobile/phones/prepay/'/>} label="New Prepay Phone &amp; SIM" />
            </RadioGroup> 
         </div>        
        ); 
        function handleChange(event) {  
            if(event.target.value =='handset')
                localStorage.setItem('planToggle',1); 
            else{
                localStorage.removeItem('planToggle');
            }
            toggleClass(event);
            props.onChange(event.target.parentNode.parentNode.getAttribute('url'));
        }
        function toggleClass(event) { 
            var arrow = document.createElement('SPAN');
            arrow.id='triangleSpan'
            arrow.classList.add('prepay-arrow-down');
            if(document.getElementById('triangleSpan')!=null || document.getElementById('triangleSpan')!=undefined)
                    document.getElementById('triangleSpan').remove();
            radioPrepay.current.classList.remove('purple-background');
            radioHandset.current.classList.remove('purple-background');
            event.target.parentNode.parentNode.parentNode.classList.add('purple-background');
            event.target.parentNode.appendChild(arrow);
        }
  }
  export default EirMobileCardToggle;
  